const MAX_VALUE = 4294967295;
let getRandomNumber = () => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions -- needed
  if (window.crypto?.getRandomValues && window.Uint32Array) {
    getRandomNumber = () => {
      const value = window.crypto.getRandomValues(new Uint32Array(1))[0];
      if (typeof value === 'undefined') {
        return Math.random();
      }
      return value / MAX_VALUE;
    };
  } else {
    getRandomNumber = () => Math.random();
  }
  return getRandomNumber();
};
export function getRandomInt(min, max) {
  const ceiledMin = Math.ceil(min);
  const flooredMax = Math.floor(max);
  return Math.floor(getRandomNumber() * (flooredMax - ceiledMin + 1)) + ceiledMin;
}
//# sourceMappingURL=getRandomInt.js.map